import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch } from '../../actions/index';

import CloseIcon from '@material-ui/icons/Close';
import { ToggleActions } from '../../constants/constants';


class TreeHeader extends React.Component {

	handleItemChange = () => {
        this.props.toggleSwitch(ToggleActions.ITEMS)
    }

	render() {
		return (
            <div>
                <div className="tree-card-header">
                    <div className="close-button-layout">
                        <span className="close-button">
                            <CloseIcon onClick={this.handleItemChange} />
                        </span>
                    </div>
                    <h4 className="text text-tree">Items</h4>
                </div>
            </div>
		);
	}
}

function mapStateToProps(){
    return {
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TreeHeader);